/**
 * @file Looks one stored report column up in `NAMED_QUERY_PRESENTATION`.
 * Consumers: `analyticsColumnText` and `analyticsReportQueryView`, for the
 * React run view and the PDF. A column or query the registry does not name
 * (an old run may hold either) falls back to its id as label and plain text
 * as format, so it still renders, as its raw cell.
 */
import type { NamedQueryId } from './Analytics.NamedQuery.types';
import { NAMED_QUERY_PRESENTATION } from './Analytics.NamedQueryPresentation.types';
import type { NamedQueryColumnPresentation, NamedQueryPresentation } from './Analytics.NamedQueryPresentation.types';

const PRESENTATIONS: Partial<Record<NamedQueryId, NamedQueryPresentation>> = NAMED_QUERY_PRESENTATION;

export const analyticsColumnPresentation = (query: NamedQueryId, column: string): NamedQueryColumnPresentation => {
  const columns: Partial<Record<string, NamedQueryColumnPresentation>> = PRESENTATIONS[query]?.columns ?? {};
  return columns[column] ?? { label: column, format: 'text' };
};
